import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "@design-system/Loader/Loader";
import { getOAuthAuthorizationUrl } from "@lib/oauth";

interface RouteParams {
    service: string;
}

export const OAuthAuthorize: React.FC = () => {
    const { service } = useParams() as Readonly<RouteParams>;

    useEffect(() => {
        getOAuthAuthorizationUrl(service).then(({ url }) => {
            window.location.href = url;
        });
    }, [service]);

    return <Loader />;
};
